import { FunctionComponent } from "react";
import ChipBase, { ChipBaseType } from "../base";

export const ChipDropdown: FunctionComponent<ChipBaseType> = (props) => {
  return <ChipBase {...props} variant="dropdown" />;
};

export default ChipDropdown;
